<template>
  <div class="neighborViewList">
    <el-card>
      <el-button type="primary" slot="header" @click="jump(), isAdd = 1">{{$t('lang.btn_add')}}</el-button>
      <el-table :data="tableData" class="wid100" :row-class-name="tableRowClassName"
        @selection-change="handleSelectionChange" :height="tableData.length > 0 ? 552 : 132">
        <el-table-column type="selection" width="55" v-if="this.neighborViewlistcheckbox"></el-table-column>
        <el-table-column type="index" :index="indexMethod" align="center" :label="$t('lang.lab_index')" width="100px">
        </el-table-column>
        <el-table-column prop="name" :label="$t('lang.lab_OwnerName')">
          <template slot-scope="scope">
            <div>{{ scope.row.name | valueIsNull }}</div>
          </template>
        </el-table-column>
        <el-table-column fixed="right" prop="operation" :label="$t('lang.lab_operation')"
          :width="require('@/config/enum').opr_width3">
          <template slot-scope="scope">
            <el-button @click="edit(scope.row.id,scope.row.name), isAdd = 0">{{$t('lang.btn_modify')}}</el-button>
            <el-button class="orange" @click="deleteOne(scope.row.id)">{{$t('lang.btn_delete')}}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNo"
        :page-sizes="[10, 20, 30, 50]" :page-size="pageSize" layout="sizes, prev, pager, next, jumper"
        :page-count="pageCount" />
    </el-card>
    <el-dialog :visible.sync="show" :close-on-click-modal="false" center top="130px" width="600px" :title="changeTitle"
      @closed="handleDialogClosed">
      <el-form ref="form" :model="form" :label-width="require('@/config/enum').c_ws4"
        :label-suffix="require('@/config/enum').c_colon" :rules="rules" class="form_show">
        <el-form-item :label="$t('lang.lab_OwnerName')" prop="name">
          <el-input v-model="form.name" :placeholder="$t('lang.lab_OwnerName')"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="rest('form')" class="cancel">{{$t('lang.btn_rest')}}</el-button>
        <el-button type="primary" :disabled="isDisabled" @click="editLabel('form')" v-if="isAdd === 0">
          {{$t('lang.btn_save')}}</el-button>
        <el-button type="primary" :disabled="isDisabled" @click="addLabel('form')" v-if="isAdd === 1">
          {{$t('lang.btn_save')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  /**
   *@ClassName:neighborViewList
   *@Description:鹰眼分类
   *@author:李忠亮
   *@Copyright:格众科技
   *@date:2020-09-02
   */
  export default {
    data() {
      return {
        show: false, // 弹框开关
        isAdd: 0, // 判断添加该是编辑
        editId: '', // 编辑页面传递的ID
        changeTitle: '', // 弹框title
        form: {
          name: '' // 表单的名字
        },
        rules: {
          labelName: [{
              required: true,
              message: this.$i18n.t('lang.lab_inputLabel'),
              trigger: 'blur'
            },
            {
              max: 10,
              message: this.$i18n.t('lang.lab_labelNameIs10'),
              trigger: 'blur'
            }
          ]
        },
        multipleSelection: [], // 多选框
        tableData: [], // 查询list
        type: '', // 1:楼 2：单元 3：房间
        pageNo: 1, // 页数
        pageSize: 10, // 每页显示数量
        pageCount: 0, // 总页数
        neighborViewlistcheckbox: require('@/config/enum').neighborViewlistcheckbox // 是否隐藏复选框
      }
    },
    watch: {
      form: {
        handler(newVal, oldVal) {
          let tempRule = JSON.stringify(newVal)
          if (tempRule === this.saveData) {
            this.isDisabled = true
          } else {
            this.isDisabled = false
          }
        },
        deep: true,
        immediate: true
      }
    },
    created() {
      this.getData()
    },
    methods: {
      // 监听关闭dialog
      handleDialogClosed() {
        this.form.name = ''
        this.$refs.form.clearValidate()
      },
      // app布局-获取列表数据
      getData() {
        let loading = this.$loading()
        this.$get(`/videoMonitorTypePage?pageSize=${this.pageSize}&pageNo=${this.pageNo}`).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              this.tableData = res.list
              this.pageCount = res.pageCount
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      // 弹出添加标签
      jump() {
        this.changeTitle = this.$i18n.t('lang.btn_add')
        this.form.labelName = ''
        this.show = true
      },
      // 点击编辑，出现弹框
      edit(id, name) {
        this.changeTitle = this.$i18n.t('lang.btn_modify')
        let loading = this.$loading()
        this.editId = id
        this.form.name = name
        loading.close()
        this.show = true
        this.saveData = JSON.stringify(this.form)
      },
        // 编辑页面传值保存
      editLabel(from) {
        this.$refs[from].validate((valid) => {
          if (valid) {
            let loading = this.$loading()
            let params = {
              name: this.form.name
            }
            this.$patch(`/videoMonitorType/${this.editId}`, params).then(
              res => {
                loading.close()
                if (res && res.errCode === 0) {
                  this.$message.success(this.$i18n.t('lang.lab_save_success'))
                  this.show = false
                  this.getData()
                }
                setTimeout(() => {
                  loading.close()
                }, 200)
              },
              error => {
                loading.close()
                this.$message.error(error)
              }
            )
          } else {
            return false
          }
        })
      },
      // 添加标签弹框确定
      addLabel(from) {
        this.$refs[from].validate((valid) => {
          if (valid) {
            // let formData = new FormData()
            // formData.append('name', this.form.labelName)
            let params = {
              name: this.form.name
            }
            let loading = this.$loading()
            this.$post(`/videoMonitorType/`, params).then(
              res => {
                loading.close()
                if (res && res.errCode === 0) {
                  this.$message.success(this.$i18n.t('lang.lab_save_success'))
                  this.show = false
                  this.getData()
                }
                setTimeout(() => {
                  loading.close()
                }, 200)
              },
              error => {
                loading.close()
                this.$message.error(error)
              }
            )
          } else {
            return false
          }
        })
      },
      // 弹框点击取消按钮
      rest(form) {
        this.$refs[ form ].resetFields()
        this.form.name = ''
      },
      // 删除
      deleteOne(id) {
        let loading = this.$loading()
        this.$confirm(this.$i18n.t('lang.lab_isdelete'), this.$i18n.t('lang.lab_prompt'), {
            confirmButtonText: this.$i18n.t('lang.btn_confirm'),
            cancelButtonText: this.$i18n.t('lang.btn_cancel'),
            type: 'warning'
          }).then(() => {
            this.$delete(`/videoMonitorType/` + id).then(
              res => {
                loading.close()
                if (res && res.errCode === 0) {
                  this.$message({
                    type: 'success',
                    message: this.$i18n.t('lang.lab_del_success')
                  })
                  this.commit()
                }
              },
              error => {
                loading.close()
                this.$message.error(error)
              }
            )
          })
          .catch(() => {
            loading.close()
            this.$message({
              type: 'info',
              message: this.$i18n.t('lang.lab_del_can')
            })
          })
      },
      // 查询
      commit() {
        this.pageNo = 1
        this.getData()
      },
      // 翻页
      handleCurrentChange(val) {
        this.pageNo = val
        this.getData()
      },
      // 切换每页显示多少数据
      handleSizeChange(val) {
        this.pageNo = 1
        this.pageSize = val
        this.getData()
      },
      // 表格斑马
      tableRowClassName({
        row,
        rowIndex
      }) {
        return rowIndex % 2 === 0 ? 'row-dark' : ''
      },
      // 多选框
      handleSelectionChange(val) {
        this.multipleSelection = val
      },
      // ID序号功能
      indexMethod(index) {
        return (this.pageNo - 1) * this.pageSize + index + 1
      },
    }
  }
</script>

<style lang="scss">
  .el-tooltip__popper.is-light {
    max-width: 300px;
  }

  .img {
    width: 40px;
    height: 40px;
    border: 1px solid lightgray;
    border-radius: 5px;
    padding: 5px;
  }

  .img-width {
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    white-space: nowrap !important;
    max-width: 320px;
  }
</style>